import { constants } from '@approvalmax/utils';

const debugTimeout = 30 * constants.time.secondsMs;

// use this flag for debugging and testing
export const getForceCheckWebAppVersion = () => {
    try {
        return localStorage.getItem('forceCheckWebAppVersion') === 'true';
    } catch {
        return false;
    }
};

export const forceCheckWebAppVersion = getForceCheckWebAppVersion();
export const toastMaxTimeout = forceCheckWebAppVersion ? debugTimeout : 8 * constants.time.hoursMs;
export const nextToastDelay = forceCheckWebAppVersion ? debugTimeout : 48 * constants.time.hoursMs;
export const refetchAppVersionInterval = forceCheckWebAppVersion ? debugTimeout : 15 * constants.time.minutesMs;
